import { useGetTeamByIdQuery } from 'src/api/redux/teams';

export const useGetTeam = ({ id }: { id: string }) => {
  return useGetTeamByIdQuery(id, { skip: !id });
};

export default useGetTeam;
